import Container from "components/Container";
import { useBreadcrumb } from "features/breadcrumbs";
import ListaRelatorioAuditoria from "./components/ListaRelatorioAuditoria";

function RelatorioAuditoria() {
  useBreadcrumb([
    { name: "Relatórios" },
    {
      name: "Auditoria",
      url: "/relatorios/auditoria",
    },
  ]);

  return (
    <Container>
      <ListaRelatorioAuditoria />
    </Container>
  );
}

export default RelatorioAuditoria;
